<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400 tx-12">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
          	<th>{{$t("transfer.内部ID")}}</th>
          	<th>{{$t("transfer.客户信息")}}</th>
            <th>{{$t("transfer.包裹物品备注")}}</th>
            <th>{{$t("transfer.仓库/创建时间")}}</th>
            <th>{{$t("transfer.货架号")}}</th>
            <th>{{$t("transfer.入库/转运时间")}}</th>
            <th>{{$t("transfer.快递单号")}}</th>
            <th>{{$t("transfer.状态")}}</th>
            <th>{{$t("transfer.体积重(cm)/包裹重(g)")}}</th>
            <th class="tx-center">{{$t("transfer.操作日志")}}</th>
            <th>{{$t("transfer.操作")}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id+index">
          	<td class="valign-middle">
            	<span class="tx-white">{{item.id}}</span>
            </td>
            <td class="valign-middle">
            	<p class="mg-b-5">
		      			<span class="tx-white">{{item.distributorName?item.distributorName:'---'}}</span>
            	</p>
            	<p class="mg-b-0">
		      			<span class="tx-white">{{item.distributorMobile?item.distributorMobile:'---'}}</span>
            	</p>
            </td>
            <td class="valign-middle">
            	<span class="tx-white">{{item.packageRemark ? item.packageRemark : '---'}}</span>
            </td>
            <td class="valign-middle">
            	<p class="mg-b-5">
		      			<span class="tx-white">{{item.addressName}}</span>
            	</p>
            	<p class="mg-b-0">
		      			<span class="tx-white">{{item.timeCreated}}</span>
            	</p>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{item.shelfCode || '---'}}</span>
            </td>
            <td class="valign-middle">
              <p class="mg-b-5">
		      			<span class="tx-white">{{item.timeStoraged?item.timeStoraged:'---'}}</span>
            	</p>
            	<p class="mg-b-0">
		      			<span class="tx-white">{{item.timeTransported?item.timeTransported:'---'}}</span>
            	</p>
            </td>
            <td class="valign-middle">
             	<span class="tx-white">{{item.companyName}} {{item.trackNumber}}</span>
            </td>
            <td class="valign-middle">
              <span  :class="item.status | statusClass">{{$t($dict.transferLandStatus[item.status])}}</span>
            </td>
            <td class="valign-middle">
            	<p class="mg-b-5">
            		<span>{{$t("transfer.体积重：")}}</span>
            		<span class="tx-white">{{item.long}}*{{item.width}}*{{item.height}}</span>
            	</p>
            	<p class="mg-b-0">
            		<span>{{$t("transfer.包裹重：")}}</span>
		      			<span class="tx-white">{{item.weight}}</span>
            	</p>
            </td>
            <td class="valign-middle">
            	<div class="d-flex justify-content-center align-items-center">
            		<a v-if="item.operateLog" href="javascript:;" @click="openLog(index)">
	            		<i class="icon ion-chatbox-working tx-20 tx-info"></i>
	            	</a>
	            	<a v-else href="javascript:;">
	            		<i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
	            	</a>
	            	<a style="display: inline-block;
	    width: 30px;
	    height: 30px;
	    border: 1px solid #ddd;
	    background-size: 100%;
	    margin-left: 10px;" href="javascript:;" v-lazy:background-image="item.imgUrl" @click="preview(index)">
	            	</a>
            	</div>
            </td>
            <td class="valign-middle">
            	<p class="mg-b-5"  v-if="item.status != 3 && item.status != 8 && item.status != 9">
            		<a href="javascript:;" class="tx-info" @click="edit(item)">{{$t("transfer.修改")}}</a>
            	</p>
            	<p class="mg-b-5" v-if="item.status != 3 && item.status != 8 && item.status != 9">
            		<a href="javascript:;" class="tx-danger" @click="cancel(item,'1')">{{$t("transfer.标记为异常")}}</a>
            	</p>
            	<p class="mg-b-5" v-if="item.status == 8">
            		<a href="javascript:;" class="tx-danger" @click="cancel(item,'2')">{{$t("transfer.取消标记为异常")}}</a>
            	</p>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!items || items.length < 1) && !first_loading">
          <tr>
            <td colspan="10">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("transfer.没有符合条件的数据")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items", "first_loading"],
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
    statusClass(val) {
      if (!val) return;
      let className = "";
      switch (val) {
        case "1":
          className = "tx-warning";
          break;
        case "2":
          className = "tx-success";
          break;
        case "3":
          className = "tx-primary";
          break;
        case "8":
          className = " tx-danger";
          break;
        case "9":
          className = " tx-white-4";
          break;
      }
      return className;
    },
    formatDate(val) {
      if(!val) return '----';
      return moment(val, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD");
    }
  },
  methods: {
  	preview(index) {
  		if(!this.items[index].imgUrl) return;
  		this.$parent.loading = true;
  		let imgArr = [];
			imgArr.push({
          img: this.items[index].imgUrl,
          text: this.items[index].name
      	})
			this.$store.commit("setImgItem", imgArr.slice(index).concat(imgArr.slice(0,index)));
	    setTimeout(() => {
	      const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.show();
        this.$parent.loading = false;
	    }, 500);

    },
  	cancel(item,type){
  		this.$emit("cancel",item,type)
  	},
  	edit(item){
  		this.$emit("edit",item)
  	},
  	openLog(i){
  		this.$emit("openLog",i);
  	},
  }
};
</script>

